import Routes from "./Routes";

export const ASSET_QUEUE = [
	{
		name: "Asset Review",
		route: Routes.ASSET_REVIEW(),
		active: true,
		themeColor: "#7feb82ab",
	},
];
